<template>
  <v-dialog v-model="editDialog" max-width="500px" persistent scrollable>
    <v-card v-if="selectedItem != null" style="border-radius: 10px">
      <v-toolbar dark class="elevation-0" color="primary">
        <v-toolbar-title
          ><h4 style="color: black">Edit User</h4></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-icon @click="cancel()" color="black" v-if="!isEditing">close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto" class="px-4 pt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <div
            style="
              display: flex;
              justify-content: center;
              cursor: pointer;
              position: relative;
            "
            @click="$refs.AvatarInput.click()"
          >
            <div
              style="
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                position: absolute;
                z-index: 1;
                width: 120px;
                height: 120px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 5px;
                background-color: rgba(0, 0, 0, 0.5);
              "
            >
              <v-icon color="white">edit</v-icon>
            </div>
            <v-img
              v-if="imageSrc"
              color="info"
              class="white--text"
              :src="imageSrc"
              max-width="120px"
              height="120px"
              style="position: relative; z-index: 0"
            />
            <v-img
              v-else-if="selectedItem.user_partner_image"
              color="info"
              class="white--text"
              :src="selectedItem.user_partner_image"
              max-width="120px"
              height="120px"
              style="position: relative; z-index: 0"
            />
          </div>
          <input
            style="display: none"
            type="file"
            @change="onAvatarSelected"
            ref="AvatarInput"
            accept="image/*"
          />
          <v-layout row>
            <v-flex xs2 class="mr-2">
              <v-select
                :items="country_tel"
                v-model="selectedItem.user_partner_country_tel"
                label="Select"
              ></v-select>
            </v-flex>
            <v-flex xs9 class="ml-2">
              <v-text-field
                v-model="selectedItem.user_partner_tel"
                label="Tel."
                :rules="[telValid.leng, telValid.required]"
                :loading="isCheckingTel"
                @input="checkTel()"
              ></v-text-field>
            </v-flex>
            <v-flex
              xs1
              class="ml-2"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div
                :style="{
                  backgroundColor: validTel == true ? '#4caf50' : 'red',
                }"
                style="
                  background-color: red;
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <v-icon color="white" size="20">{{
                  validTel == true ? "check" : "close"
                }}</v-icon>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs6 class="mr-2">
              <v-text-field
                v-model="selectedItem.user_partner_first_name"
                label="First name"
                :rules="[nameValid.max, nameValid.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="ml-2">
              <v-text-field
                v-model="selectedItem.user_partner_last_name"
                label="Last name"
                :rules="[nameValid.max, nameValid.required]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <!-- <v-text-field
            v-model="selectedItem.user_partner_email"
            label="Email"
            :rules="[
              emailValid.email,
              emailValid.required,
              emailValid.already,
              nameValid.max,
            ]"
          ></v-text-field> -->
          <v-autocomplete
            v-model="selectedItem.user_partner_province_id"
            :items="province_list"
            outlined
            :loading="loadingProvince"
            item-text="province_name_th"
            item-value="province_id"
            dense
            label="Select Province"
            @change="
              selectedItem.user_partner_district_id = [];
              districtList = [];
              getDistrictList();
            "
          ></v-autocomplete>
          <v-autocomplete
            v-model="selectedItem.user_partner_district_id"
            :items="districtList"
            outlined
            :loading="loadingDistrict"
            item-text="district_name_th"
            item-value="district_id"
            dense
            chips
            small-chips
            label="Select District"
            multiple
          ></v-autocomplete>
          <!-- <div class="line-changepass"></div>
          <v-text-field
            v-model="password1"
            :append-icon="show1 ? 'visibility_off' : 'visibility'"
            :type="show1 ? 'text' : 'password'"
            autocomplete="new-password"
            label="New Password"
            hint="At least 6 characters and No more than 24 characters"
            @click:append="show1 = !show1"
          ></v-text-field>
          <v-text-field
            v-model="password2"
            :append-icon="show2 ? 'visibility_off' : 'visibility'"
            :type="show2 ? 'text' : 'password'"
            autocomplete="new-password"
            label="Confirm New Password"
            hint="At least 6 characters and No more than 24 characters"
            @click:append="show2 = !show2"
          ></v-text-field>
          <div v-if="passwordMatch == false">Password Not match ...</div> -->
        </v-form>
      </v-card-text>
      <v-card-actions style="padding-bottom: 30px" class="pr-4">
        <v-spacer></v-spacer>

        <v-btn
          dark
          color="black"
          style="
            width: 120px;
            background: #000000 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 7px;
            font-weight: bold;
            letter-spacing: 0.1rem;
          "
          flat
          :loading="isEditing"
          @click="save()"
          ><span style="color: white"> Save</span></v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  props: ["selectedItem", "editDialog", "originalUser"],
  data() {
    return {
      districtList: [],
      isEditing: false,
      loadingProvince: false,
      loadingDistrict: false,
      country_tel: ["+66"],
      passwordMatch: true,
      user_province_type: 1,
      selected: [],
      originalTel: "",
      verifyEmail: [
        {
          name: "verified",
          value: true,
        },
        {
          name: "not verified",
          value: false,
        },
      ],
      password1: "",
      password2: "",
      show1: false,
      show2: false,
      valid: true,
      imageSrc: null,
      telValid: {
        required: (value) => !!value || "Required.",
        leng: (v) => v.length == 9 || "9 characters only",
      },
      nameValid: {
        required: (value) => !!value || "Required.",
        max: (v) => v.length <= 55 || "Min 55 characters",
      },
      // emailValid: {
      //   already: (a) => !this.emailAlready(a) || "Already in use",
      //   required: (value) => !!value || "Required.",
      //   email: (value) => {
      //     const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      //     return pattern.test(value) || "Invalid e-mail.";
      //   },
      // },
      roleValid: {
        required: (value) => (!!value && value !== 0) || "Required.",
      },
      debouceTel: null,
      isCheckingTel: false,
      validTel: true,
    };
  },
  watch: {
    async editDialog() {
      if (this.editDialog == true) {
        this.loadingProvince = true;
        await this.$store.dispatch("fetchProvinceBack/getData");
        if (this.selectedItem.user_partner_province_id != null) {
          await this.getDistrictList();
        }
        this.originalTel = JSON.parse(
          JSON.stringify(this.selectedItem.user_partner_tel)
        );
        this.loadingProvince = false;
      }
    },
  },
  computed: {
    ...mapState({
      userData: (state) => state.fetchUserBack.userData,
      // province_list: state => state.fetchProvinceBack.provinceData
    }),
    ...mapGetters({
      isEditStaff: "isEditStaff",
      province_list: "fetchProvinceBack/provinceSplited",
    }),
  },
  methods: {
    ...mapActions({
      getDistrictCore: "fetchProvinceBack/getDistrictCore",
      checkManagerTel: "fetchUserBack/checkManagerTel",
    }),
    onAvatarSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imageSrc = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    async checkTel() {
      this.validTel = false;
      clearTimeout(this.debouceTel);
      if (this.selectedItem.user_partner_tel.length != 9)
        return (this.isCheckingTel = false);

      this.isCheckingTel = true;
      let _this = this;
      this.debouceTel = setTimeout(async function () {
        let config = {
          tel: _this.selectedItem.user_partner_tel,
        };
        let res = await _this.checkManagerTel(config);
        if (_this.selectedItem.user_partner_tel == _this.originalTel) {
          _this.validTel = true;
        } else {
          _this.validTel = res;
        }
        _this.isCheckingTel = false;
      }, 1000);
    },
    async getDistrictList() {
      this.loadingDistrict = true;
      this.districtList = await this.getDistrictCore(
        this.selectedItem.user_partner_province_id
      );
      this.loadingDistrict = false;
    },
    cancel() {
      Object.assign(this.selectedItem, this.originalUser);
      this.$emit("setOriginal", null);
      this.$emit("setDialog", false);
    },
    async save() {
      if (this.$refs.form.validate() && this.validTel == true) {
        let payload = JSON.parse(JSON.stringify(this.selectedItem));
        if (this.imageSrc == null) {
          delete payload.user_partner_image;
        } else {
          payload.user_partner_image = this.imageSrc;
        }
        this.isEditing = true;
        let _this = this;
        this.$emit("onSaved", {
          form: payload,
          done() {
            _this.isEditing = false;
            return;
          },
        });
      }
    },
  },
};
</script>

<style>
.line-changepass {
  overflow: visible;
  padding: 0;
  border: none;
  border-top: 2px solid black;
  color: #333;
  text-align: center;
  margin-top: 25px;
}

.line-changepass:after {
  content: "Change Password";
  display: inline-block;
  position: relative;
  top: -0.8em;
  font-size: 17px;
  padding: 0 0.25em;
  background: white;
}
</style>
